import de from "./locales/de";
import it from "./locales/it";
import es from "./locales/es";
import fr from "./locales/fr";
import en from "./locales/en";
import ptPT from "./locales/ptPT";
import ptBR from "./locales/ptBR";

export const LANGS = [
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "it", label: "Italiano", short: "IT" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "en", label: "English", short: "EN" },
  { code: "pt-pt", label: "Português (Portugal)", short: "PT-PT" },
  { code: "pt-br", label: "Português (Brasil)", short: "PT-BR" },
];

export const DEFAULT_LANG = "de";
export const LANG_CODES = LANGS.map((l) => l.code);

export const LOCALES = { de, it, es, fr, en, "pt-pt": ptPT, "pt-br": ptBR };

export const PAGE_SLUGS = {
  home: { de: "", it: "", es: "", fr: "", en: "", "pt-pt": "", "pt-br": "" },
  treatments: { de: "behandlungen", it: "trattamenti", es: "tratamientos", fr: "soins", en: "treatments", "pt-pt": "tratamentos", "pt-br": "tratamentos" },
  about: { de: "ueber-mich", it: "chi-sono", es: "sobre-mi", fr: "a-propos", en: "about-me", "pt-pt": "sobre-mim", "pt-br": "sobre-mim" },
  studio: { de: "studio", it: "studio", es: "estudio", fr: "studio", en: "studio", "pt-pt": "estudio", "pt-br": "estudio" },
  contact: { de: "kontakt", it: "contatto", es: "contacto", fr: "contact", en: "contact", "pt-pt": "contacto", "pt-br": "contato" },
  impressum: { de: "impressum", it: "impressum", es: "impressum", fr: "impressum", en: "impressum", "pt-pt": "impressum", "pt-br": "impressum" },
  privacy: { de: "datenschutz", it: "protezione-dei-dati", es: "proteccion-de-datos", fr: "protection-des-donnees", en: "privacy", "pt-pt": "privacidade", "pt-br": "privacidade" },
};

export function isLang(code) {
  return LANG_CODES.includes(code);
}

export function pathFor(lang, pageKey, treatmentSlug) {
  const seg = PAGE_SLUGS[pageKey] ? PAGE_SLUGS[pageKey][lang] : "";
  let p = `/${lang}`;
  if (seg) p += `/${seg}`;
  if (pageKey === "treatments" && treatmentSlug) p += `/${treatmentSlug}`;
  return p;
}

export function resolvePage(lang, seg1, seg2, treatments, categories = []) {
  if (!seg1) return { pageKey: "home" };
  for (const [key, slugs] of Object.entries(PAGE_SLUGS)) {
    if (key === "home") continue;
    if (slugs[lang] === seg1) {
      if (key === "treatments" && seg2) {
        const t = treatments.find((tr) => tr.slugs[lang] === seg2);
        if (t) return { pageKey: "treatment", treatment: t };
        const c = categories.find((cat) => cat.slugs[lang] === seg2);
        if (c) return { pageKey: "category", category: c };
        return { pageKey: "notfound" };
      }
      if (key !== "treatments" && seg2) return { pageKey: "notfound" };
      return { pageKey: key };
    }
  }
  return { pageKey: "notfound" };
}
